import { authenticatedRequest } from './api';

const API_BASE = '/admin/categories';

export const schemaService = {
  // Get all schemas with optional filters
  async getSchemas(params = {}) {
    try {
      const queryString = new URLSearchParams(params).toString();
      const url = queryString ? `${API_BASE}/form-configs/?${queryString}` : `${API_BASE}/form-configs/`;
      const response = await authenticatedRequest(url);
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || error.message || 'Failed to fetch schemas'
      };
    }
  },

  // Get schemas by category
  async getSchemasByCategory(categorySid) {
    try {
      const response = await authenticatedRequest(`${API_BASE}/form-configs/?category__sid=${categorySid}`);
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || error.message || 'Failed to fetch schemas'
      };
    }
  },

  // Get schema by ID
  async getSchema(schemaId) {
    try {
      const response = await authenticatedRequest(`${API_BASE}/form-configs/${schemaId}/`);
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || error.message || 'Failed to fetch schema'
      };
    }
  },

  // Create new schema
  async createSchema(schemaData) {
    try {
      const response = await authenticatedRequest(`${API_BASE}/form-configs/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(schemaData)
      });
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || error.message || 'Failed to create schema'
      };
    }
  },

  // Update schema
  async updateSchema(schemaId, schemaData) {
    try {
      const response = await authenticatedRequest(`${API_BASE}/form-configs/${schemaId}/`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(schemaData)
      });
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || error.message || 'Failed to update schema'
      };
    }
  },

  // Delete schema
  async deleteSchema(schemaId) {
    try {
      await authenticatedRequest(`${API_BASE}/form-configs/${schemaId}/`, {
        method: 'DELETE'
      });
      return {
        success: true
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || error.message || 'Failed to delete schema'
      };
    }
  },

  // Get schema versions
  async getSchemaVersions(schemaId) {
    try {
      const response = await authenticatedRequest(`${API_BASE}/form-configs/${schemaId}/versions/`);
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || error.message || 'Failed to fetch schema versions'
      };
    }
  },

  // Rollback to version
  async rollbackToVersion(schemaId, version) {
    try {
      const response = await authenticatedRequest(`${API_BASE}/form-configs/${schemaId}/rollback/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ version })
      });
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || error.message || 'Failed to rollback schema'
      };
    }
  },

  // Validate JSON
  async validateJson(jsonData) {
    try {
      const response = await authenticatedRequest(`${API_BASE}/form-configs/validate_json/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(jsonData)
      });
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || error.message || 'JSON validation failed'
      };
    }
  },

  // Get schema by category
  async getSchemaByCategory(categoryId) {
    try {
      const response = await authenticatedRequest(`${API_BASE}/form-configs/by_category/?category_id=${categoryId}`);
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || error.message || 'Failed to fetch schema by category'
      };
    }
  }
};
